import React from "react";
import Button from "../../../../../components/ui/Button";

const SubscriptionCard = ({ subscription }) => {
  return (
    <div className="bg-white p-4 rounded-xl border border-slate-200 flex items-center space-x-4">
      <img
        src={subscription.creatorProfilePicture}
        alt={subscription.creatorName}
        className="w-16 h-16 rounded-lg object-cover"
      />
      <div className="flex-grow">
        <p className="font-bold text-slate-800">{subscription.creatorName}</p>
        <p className="text-sm text-slate-500">{subscription.tierName}</p>
        <p className="text-xs text-slate-400 mt-1">
          Renews on {subscription.renewalDate}
        </p>
      </div>
      <div className="text-right flex-shrink-0">
        <p className="font-semibold text-slate-700">
          {subscription.priceETB} ETB
          <span className="text-slate-500 font-normal">/mo</span>
        </p>
        <Button size="sm" variant="ghost" className="mt-1">
          Manage
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionCard;
